import { render, staticRenderFns } from "./ContactPerDeps.vue?vue&type=template&id=625fb2e2&"
import script from "./ContactPerDeps.vue?vue&type=script&lang=js&"
export * from "./ContactPerDeps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625fb2e2')) {
      api.createRecord('625fb2e2', component.options)
    } else {
      api.reload('625fb2e2', component.options)
    }
    module.hot.accept("./ContactPerDeps.vue?vue&type=template&id=625fb2e2&", function () {
      api.rerender('625fb2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/ContactPerDeps.vue"
export default component.exports